export default {
  adminData(state, payload) {
    state.adminId = payload.adminId;
    state.companyId = payload.companyId;
  },
  accountsTimestamp(state) {
    state.accountsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  accountsData(state, payload) {
    state.companies = payload.companies;
    state.users = payload.users;
  },
  userData(state, payload) {
    state.users = payload;
  },
  companyData(state, payload) {
    state.companies = payload;
  },
};
